<template>
  <div v-loading.fullscreen.lock="$store.getters.isRequesting" style="height: 100%; width: 100%;">
    <transition enter-active-class="animated bounceInRight" leave-active-class="wrapperOut">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Base'
}
</script>
